import { createContext, useContext, useState } from 'react';

interface AppCtxValue {
  horizon: number;
  setHorizon: (n: number) => void;
  dataStamp: Date | null;
  setDataStamp: (d: Date | null) => void;
}

const AppCtx = createContext<AppCtxValue>({
  horizon: 45,
  setHorizon: () => {},
  dataStamp: null,
  setDataStamp: () => {},
});

export function AppCtxProvider({ children }: { children: React.ReactNode }) {
  const [horizon, setHorizon] = useState(45);
  const [dataStamp, setDataStamp] = useState<Date | null>(null);
  return (
    <AppCtx.Provider value={{ horizon, setHorizon, dataStamp, setDataStamp }}>
      {children}
    </AppCtx.Provider>
  );
}

export const useAppCtx = () => useContext(AppCtx);
